import iziToast from 'izitoast/dist/js/iziToast.min.js';
import Message from "../components/Message";
import DeleteProductsProfile from "../components/DeleteProductsProfile";
export default (function (w, d) {
    'use strict';

    function ProductsForSaleController() {
        this.initController();
    }

    ProductsForSaleController.prototype.initController = function () {
        $('.product-status-checkbox').on("change", function(){
            let $product_status;
            $product_status = 0;
            if(this.checked) {
                $product_status = 1;
            }
            var product_id = $(this).data('product-id');
            var product_attribute_id = $(this).data('product-attribute-id');
            var checked = $(this).prop('checked');
            $.ajax({
                url: $(this).data('url'),
                method: 'post',
                headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
                data: {
                    product_id: $(this).data('product-id'),
                    product_attribute_id: $(this).data('product-attribute-id'),
                    product_status: $product_status
                },
                success: function(response) {
                    if(response.status == 'success'){

                        if(!product_attribute_id) {
                            $('.product-status-checkbox-' + product_id).prop('checked', checked);
                        }

                        iziToast.show({
                            message: response.message,
                            backgroundColor: '#fff',
                            position: 'topRight',
                            timeout: 5000,
                            progressBarColor: '#000',
                            overlayColor: 'rgba(0, 0, 0, 0)',
                            class: 'success-product',
                        });
                        location.reload();
                    }else{
                        iziToast.show({
                            message: response.message,
                            backgroundColor: '#fac4bc',
                            position: 'topRight',
                            timeout: 5000,
                            progressBarColor: '#ffeeeb',
                            overlayColor: 'rgba(0, 0, 0, 0)',
                            class: 'success-product'
                        });
                    }
                },
                error: function(response) {}
            });
        });

        new DeleteProductsProfile;
    }

    return ProductsForSaleController;
}(window, document));

